import React, { useState } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, FIRESTORE_DB } from "../../Database/Database";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  // 📌 NUEVOS ESTADOS: Control de visibilidad y de carga
  const [showPassword, setShowPassword] = useState(false); 
  const [loading, setLoading] = useState(false); // <--- ESTADO DE CARGA

  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true); // 📌 INICIA CARGA

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      console.log("Login exitoso!");

      // 📌 Obtener rol del usuario desde Firestore
      const userRef = doc(FIRESTORE_DB, "users", user.uid);
      const userSnap = await getDoc(userRef);

      console.log("UID:", user.uid);
      console.log("Documento encontrado:", userSnap.data());

      if (userSnap.exists()) {
        const { role } = userSnap.data();

        if (!role) {
          setError("Este usuario no tiene un rol asignado");
          setLoading(false); // Finaliza carga en error
          return;
        }

        localStorage.setItem("role", role);

        // 📌 Redirigir según rol
        if (role === "administrador") {
          navigate("/verProductos");
        } else if (role === "empleado") {
          navigate("/ventas");
        } else {
          setError("Rol desconocido");
        }

      } else {
        setError("El usuario no tiene un documento en Firestore");
      }
      
      setLoading(false); // 📌 FINALIZA CARGA en éxito

    } catch (err) {
      // 📌 FINALIZA CARGA en error
      setLoading(false); 
      // Mapeo de errores de Firebase comunes a mensajes amigables
      if (err.code === 'auth/invalid-email' || err.code === 'auth/user-not-found') {
        setError("Correo o contraseña incorrectos.");
      } else if (err.code === 'auth/wrong-password') {
        setError("Contraseña incorrecta. Por favor, verifica tus credenciales.");
      } else {
        setError(`Error al iniciar sesión: ${err.message}`);
      }
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        
        <h2 className="login-title">Bienvenido a Gestión Colibries</h2>
        <p>Ingrese su usuario y contraseña</p>

        <form onSubmit={handleLogin} className="login-form">

          <input
            type="email"
            placeholder="📧 Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="login-input"
            disabled={loading} // 📌 DESHABILITAR mientras carga
          />

          <div className="password-input-container">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="🔒 Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="login-input"
              disabled={loading} // 📌 DESHABILITAR mientras carga
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="toggle-password-button"
              aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
              disabled={loading} // 📌 DESHABILITAR mientras carga
            >
              {showPassword ? "👁️" : "🙈"}
            </button>
          </div>

          {error && <p className="login-error-message">Error de usuario/contraseña</p>}

          <button 
            type="submit" 
            className="login-button"
            disabled={loading} // 📌 DESHABILITAR el botón de envío
          >
            {/* 📌 MOSTRAR SPINNER O TEXTO */}
            {loading ? (
              <div className="spinner"></div> // Componente spinner en CSS
            ) : (
              "Ingresar"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;